import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { ExternalLink } from 'lucide-react'
import GlassCard from '../ui/GlassCard'

const PartnersSection = () => {
  const { t } = useTranslation()

  // Configuration des partenaires avec leurs logos depuis le repo GitHub
  // Base URL pour les images depuis le repository BrandBoostApp/image-
  const baseImageUrl = 'https://raw.githubusercontent.com/BrandBoostApp/image-/main/'
  
  const partners = [
    {
      id: 1,
      name: 'ARIQH',
      logo: `${baseImageUrl}Ariqh%20Logo.png`,
      website: '#',
      description: 'Association régionale pour l\'intégration des personnes handicapées du Québec'
    },
    {
      id: 2,
      name: 'CRDITED', 
      logo: `${baseImageUrl}CRDITED%20Logo.jpeg`,
      website: '#',
      description: 'Centre de réadaptation en déficience intellectuelle et en troubles envahissants du développement'
    },
    {
      id: 3,
      name: 'Partenaire Institutionnel',
      logo: `${baseImageUrl}images.png`,
      website: '#',
      description: 'Institution partenaire pour l\'accompagnement des résidents'
    }
  ]

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-display font-bold gradient-text mb-4">
            Nos Partenaires
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nous sommes fiers de collaborer avec des organisations qui partagent nos valeurs et notre engagement envers l'accompagnement personnalisé.
          </p>
        </motion.div>

        {/* Grille des partenaires */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8"
        >
          {partners.map((partner, index) => (
            <motion.div
              key={partner.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <GlassCard className="h-full p-6 text-center group hover:scale-105 transition-transform duration-300">
                {/* Logo du partenaire */}
                <div className="mb-6 relative">
                  <div className="w-24 h-24 mx-auto mb-4 relative overflow-hidden rounded-xl bg-white shadow-lg">
                    <img
                      src={partner.logo}
                      alt={`Logo ${partner.name}`}
                      className="w-full h-full object-contain p-2"
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/150x100?text=Logo+Indisponible'
                      }}
                    />
                  </div>
                  
                  {/* Indicateur de lien externe */}
                  {partner.website !== '#' && (
                    <div className="absolute -top-2 -right-2 bg-primary-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <ExternalLink className="w-4 h-4" />
                    </div>
                  )}
                </div>

                {/* Informations du partenaire */}
                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-black group-hover:text-primary-600 transition-colors">
                    {partner.name}
                  </h3>
                  
                  {partner.description && (
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {partner.description}
                    </p>
                  )}

                  {/* Lien vers le site web */}
                  {partner.website !== '#' && (
                    <a
                      href={partner.website}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors"
                    >
                      Visiter le site
                      <ExternalLink className="w-4 h-4 ml-1" />
                    </a>
                  )}
                </div>
              </GlassCard>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  )
}

export default PartnersSection
